import React, { Fragment } from "react";

import { Header } from "./../Elements";

export default () => (
  <Fragment>
    <Header title="Photos" />

    <div id="content">
      <div className="col-md-10 mx-auto text-center font-weight-bold pt-2 pb-1">
      <h5 className="greenText font-weight-bold">
          <a
            href="https://youthrally.smugmug.com/Youth-Rally-2026-Photos"
            target="_blank"
            className="links"
          >
            2026 Youth Rally Photos and Videos
          </a>
        </h5>
        <h5 className="purpleText font-weight-bold">
          <a
            href="https://youthrally.smugmug.com/Youth-Rally-2025-Photos-1"
            target="_blank"
            className="links"
          >
            2025 Youth Rally Photos and Videos
          </a>
        </h5>
        <h5 className="greenText font-weight-bold">
          <a
            href="https://youthrally.smugmug.com/Youth-Rally-2024-Photos/n-vvj8j5"
            target="_blank"
            className="links"
          >
            2024 Youth Rally Photos and Videos
          </a>
        </h5>
        <h5 className="purpleText font-weight-bold">
          <a
            href="https://youthrally.smugmug.com/2023YouthRallyPhotos"
            target="_blank"
            className="links"
          >
            2023 Youth Rally Photos and Videos
          </a>
        </h5>
        <h5 className="greenText font-weight-bold">
          <a
            href="https://youthrallyphotos.smugmug.com/2019-Rally-in-Seattle-Photos"
            target="_blank"
            className="links"
          >
            2019 Youth Rally Photos and Videos
          </a>
        </h5>
        <h5 className="purpleText font-weight-bold">
          <a
            href="https://youthrallyphotos.smugmug.com/2018-Rally-in-Boulder"
            target="_blank"
            className="links"
          >
            2018 Youth Rally Photos and Videos
          </a>
        </h5>
        <h5 className="greenText font-weight-bold">
          <a
            href="https://youthrallyphotos.smugmug.com/2017-Youth-Rally"
            target="_blank"
            className="links"
          >
            2017 Youth Rally Photos
          </a>
        </h5>
        <h5 className="purpleText font-weight-bold">
          <a
            href="https://youthrallyphotos.smugmug.com/2017-Rally-in-San-Diego-Video"
            target="_blank"
            className="links"
          >
            2017 Youth Rally Videos
          </a>
        </h5>
        <h5 className="greenText font-weight-bold">
          <a
            href="https://youthrallyphotos.smugmug.com/Youth-Rally-2016-in-Seattle"
            target="_blank"
            className="links"
          >
            2016 Youth Rally Photos
          </a>
        </h5>
        <h5 className="purpleText font-weight-bold">
          <a
            href="https://youthrallyphotos.smugmug.com/2016-Rally-in-Seattle-Videos"
            target="_blank"
            className="links"
          >
            2016 Youth Rally Videos
          </a>
        </h5>
        <h5 className="greenText font-weight-bold">
          <a
            href="https://youthrallyphotos.smugmug.com/2015RallyinBoulder"
            target="_blank"
            className="links"
          >
            2015 Youth Rally Photos
          </a>
        </h5>
        <h5 className="purpleText font-weight-bold">
          <a
            href="https://youthrallyphotos.smugmug.com/2015-Rally-in-Boulder-Videos"
            target="_blank"
            className="links"
          >
            2015 Youth Rally Videos
          </a>
        </h5>
        <h5 className="greenText font-weight-bold">
          <a
            href="https://youthrallyphotos.smugmug.com/2014RallyinSanDiego"
            target="_blank"
            className="links"
          >
            2014 Youth Rally Photos
          </a>
        </h5>
        <h5 className="purpleText font-weight-bold">
          <a
            href="https://youthrallyphotos.smugmug.com/2014-Rally-in-San-Diego-Videos"
            target="_blank"
            className="links"
          >
            2014 Youth Rally Videos
          </a>
        </h5>
      </div>
    </div>
  </Fragment>
);
